import React from "react";
import { withTheme } from "@material-ui/core/styles";
import EditPouleSpot from "../../../components/settings/slideshow/EditPouleSpot";

class EditPouleSpotContainer extends React.Component {
  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection(this.props.elementType)
      .doc(this.props.structureElement.id)
      .update(newState);
  };

  render() {
    let showTypeDiaKey = "showTypeDia";
    let widthDiaKey = "widthDia";

    if (this.props.structureElement.diaNum !== undefined) {
      showTypeDiaKey += this.props.structureElement.diaNum.toString();
      widthDiaKey += this.props.structureElement.diaNum.toString();
    }

    let showType = this.props.structureElement[showTypeDiaKey] || "0";
    if (
      this.props.structureElement.singleMatch &&
      this.props.structureElement[showTypeDiaKey] === undefined
    ) {
      showType = "2";
    }
    let width = this.props.structureElement[widthDiaKey] || "3";
    if (showType === "0" && this.props.elementType === "poules") {
      width = "3";
    }
    if (
      showType === "1" &&
      this.props.elementType === "poules" &&
      !this.props.structureElement[widthDiaKey] &&
      (this.props.tournament.vrsn < 4 ||
        this.props.tournament.vrsn === undefined)
    ) {
      width = "0";
    }

    return (
      <div style={{ display: "inline-block" }}>
        <EditPouleSpot
          handleChange={this.handleChange}
          showType={showType}
          width={width}
          onlyFullWidth={
            showType === "0" && this.props.elementType === "poules"
          }
          showTypeDiaKey={showTypeDiaKey}
          widthDiaKey={widthDiaKey}
          elementType={this.props.elementType}
        />
      </div>
    );
  }
}

export default withTheme(EditPouleSpotContainer);
